import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("voyagemarkt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      // token expired/invalid
      const path = window.location.pathname;
      if (path.startsWith("/app")) {
        localStorage.removeItem("voyagemarkt_token");
        localStorage.removeItem("voyagemarkt_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
